module.exports = __webpack_public_path__ + "img/9.35d6a15d.jpg";